export default "assets/images/icons/search-75634e17.svg";